import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import DigitalServicesActBase from './digital-services-act.base';

import dsaDasImageSrc from 'assets/images/dsa/dsa-das.png';
import dsaGamImageSrc from 'assets/images/dsa/dsa-gam.png';

const DigitalServicesActDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <DigitalServicesActBase />
        <div><img src={dsaDasImageSrc} alt="Oznaczenie reklam na platformie zgodnie z DSA" /></div>
        <div><img src={dsaGamImageSrc} alt="Oznaczenie reklamowe Google Ad Manager" /></div>
    </StaticLayoutDesktop>
);

export default withHydrate(DigitalServicesActDesktop, { root: '#root' }, 'views/pages/static/digital-services-act/digital-services-act.desktop');
